export var STORY_MODAL_NOTIFICATION_EVENT = "storyModalNotificationEvent";
